/* Privacy Policy page — highlights the current section in the table of
   contents while you scroll.

   Progressive enhancement only: with JS off the TOC links are ordinary
   anchors, and smooth scrolling + the sticky-header offset are handled in CSS
   (scroll-behavior on html, scroll-margin-top on the headings).

   ES5 on purpose, to match the other section scripts in this theme. */
(function () {
  'use strict';

  /* Distance from the top of the viewport that counts as "you are reading
     here". Read from the heading's own scroll-margin-top so it always matches
     the CSS, which is in rem and therefore moves with the theme's fluid root
     font-size. 96px is the value at a 16px root. */
  var FALLBACK_LINE = 96;

  /* Pure: given each heading's viewport-relative top and the reading line,
     return the index of the heading being read. The last heading at or above
     the line wins; before the first one is reached, index 0 stays active.
     Kept side-effect free so it can be tested directly. */
  function pickActive(tops, line) {
    var idx = 0;
    for (var i = 0; i < tops.length; i++) {
      if (tops[i] - line <= 0) idx = i;
    }
    return idx;
  }

  /* istanbul ignore else -- guard for the test harness, which only wants the
     function above and has no DOM. */
  if (typeof document === 'undefined') return;

  var root = document.querySelector('[data-pp]');
  if (!root) return;

  var links = Array.prototype.slice.call(root.querySelectorAll('[data-pp-toc-link]'));
  var headings = Array.prototype.slice.call(root.querySelectorAll('[data-pp-section]'));
  if (!links.length || !headings.length) return;

  /* heading id -> its TOC link (order of the two lists can differ) */
  var linkFor = {};
  for (var i = 0; i < links.length; i++) {
    var id = (links[i].getAttribute('href') || '').replace(/^#/, '');
    if (id) linkFor[id] = links[i];
  }

  var currentId = null;

  function setActive(id) {
    if (id === currentId) return;
    currentId = id;
    for (var i = 0; i < links.length; i++) {
      var on = links[i] === linkFor[id];
      links[i].classList.toggle('is-active', on);
      if (on) {
        links[i].setAttribute('aria-current', 'true');
      } else {
        links[i].removeAttribute('aria-current');
      }
    }
  }

  var queued = 0;
  var readingLine = FALLBACK_LINE;

  function measureReadingLine() {
    var v = parseFloat(getComputedStyle(headings[0]).scrollMarginTop);
    readingLine = isNaN(v) || v <= 0 ? FALLBACK_LINE : v;
  }

  function update() {
    queued = 0;
    var tops = [];
    for (var i = 0; i < headings.length; i++) {
      tops.push(headings[i].getBoundingClientRect().top);
    }
    setActive(headings[pickActive(tops, readingLine)].id);
  }

  function onScroll() {
    if (queued) return;
    queued = window.requestAnimationFrame ? window.requestAnimationFrame(update) : setTimeout(update, 100);
  }

  function onResize() {
    measureReadingLine();
    onScroll();
  }

  measureReadingLine();
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });

  /* ---- Collapsible table of contents (mobile only) --------------------
     The design shows the TOC closed on phones and always open on desktop.
     The markup ships expanded so it still works without JS. */
  var toc = root.querySelector('[data-pp-toc]');
  var toggle = root.querySelector('[data-pp-toc-toggle]');

  if (toc && toggle) {
    var MOBILE = '(max-width: 1023px)';

    function isMobile() {
      return window.matchMedia(MOBILE).matches;
    }

    function setCollapsed(collapsed) {
      toc.setAttribute('data-collapsed', collapsed ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }

    /* Remembers which side of the breakpoint we were on, so the default is
       re-applied when the viewport crosses it but a manual toggle is kept
       while the user stays on the same side. */
    var wasMobile = isMobile();
    setCollapsed(wasMobile);

    toggle.addEventListener('click', function () {
      if (!isMobile()) return;
      setCollapsed(toc.getAttribute('data-collapsed') !== 'true');
    });

    window.addEventListener('resize', function () {
      var m = isMobile();
      if (m === wasMobile) return;
      wasMobile = m;
      setCollapsed(m);
    }, { passive: true });

    /* Following a link inside the panel closes it again on mobile. */
    toc.addEventListener('click', function (e) {
      if (isMobile() && e.target.closest('[data-pp-toc-link]')) setCollapsed(true);
    });
  }
}());
